module.exports = __webpack_public_path__ + "static/media/122.5fe8a544.webp";